import { alpha } from '@mui/material'
import { EditorView } from '@uiw/react-codemirror'
import { Theme } from '@mui/material'

export const createAssetChipTheme = (theme: Theme) =>
  EditorView.theme({
    '.cm-asset-chip': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '2px',
      padding: '0 6px',
      borderRadius: '12px',
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
      color: theme.palette.primary.dark,
      fontSize: '0.9em',
      lineHeight: '1.6',
      verticalAlign: 'baseline',
    },
    '.cm-asset-chip-edit': {
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: '3px',
      marginRight: '-3px',
      padding: '0 4px',
      borderRadius: '8px',
      whiteSpace: 'nowrap',
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.primary.dark,
      fontSize: '0.75em',
      border: `1px solid ${alpha(theme.palette.primary.main, 0.4)}`,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        borderColor: theme.palette.primary.main,
      },
    },
    '.cm-asset-chip-label': {
      color: 'inherit',
      textDecoration: 'none',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '.cm-asset-chip:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
    },
  })
